import {
  GET_ALGOLIA_SEARCH_HC_PROVIDER,
  SET_ALGOLIA_SEARCH_HC_PROVIDER,
  GET_ALGOLIA_SEARCH_USERS,
  SET_ALGOLIA_SEARCH_USERS,
  SET_PATIENTS_HC_PROVIDER,
  SET_PATIENTS_VIRUSES,
  SET_PATIENTS_DEPENDENTS_VIRUSES,
  SET_PATIENTS_ALL_VIRUSES,
  SET_CURRENT_PATIENTS,
  SET_DATA_PATIENTS_HC_PROVIDER,
  SET_USER_FOR_ID
} from '../types';

import {s3Upload} from '../../helper/s3Upload';
import {showAlert, setLoadSpinner} from './uiActions';
import {setAWSLamda} from '../../api';


export const getAlgoliaSearchHcProviderData = (searchValue) => {
  return {
    type: GET_ALGOLIA_SEARCH_HC_PROVIDER,
    payload: searchValue
  };
};

export const setAlgoliaSearchHcProviderData = (searchResult) => {
  return {
    type: SET_ALGOLIA_SEARCH_HC_PROVIDER,
    payload: searchResult
  };
};

export const getAlgoliaSearchUsers = (searchValue) => {
  return {
    type: GET_ALGOLIA_SEARCH_USERS,
    payload: searchValue
  };
};

export const setAlgoliaSearchUsers = (searchResult) => {
  return {
    type: SET_ALGOLIA_SEARCH_USERS,
    payload: searchResult
  };
};

export const getPatientsHcProvider = (hcProviderId) => {
  return async (dispatch, getState, {getFirebase, getFirestore}) => {
    const firestore = getFirestore();
    const patients = [];
    await firestore.collection('patients').doc(hcProviderId).get().then(snap => {
      if (snap.data()) {
        snap.data().list.map(p => patients.push(p));
      }
      ;
    });

    return dispatch(setPatientsHcProvider({patientsHcProvider: patients}));
  };
};

export const setPatientsHcProvider = (patients) => {
  return {
    type: SET_PATIENTS_HC_PROVIDER,
    payload: patients
  };
};

export const getDataPatientsHcProvider = (patients) => {
  return async (dispatch, getState, {getFirebase, getFirestore}) => {
    const firestore = getFirestore();

    const patientsPromise = patients.map(async (patient) => (
      await firestore.collection('users').doc(patient).get()
    ));
    const allPatients = await Promise.all(patientsPromise);

    const dataPatients = allPatients.map((patient) => (
      patient.data()
    ));

    return dispatch(setPatientsHcProvider({dataPatients}));
  };
};

export const setDataPatientsHcProvider = (patients) => {
  return {
    type: SET_DATA_PATIENTS_HC_PROVIDER,
    payload: patients
  };
};

export const getPatientViruses = (userId) => {
  return async (dispatch, getState, {getFirebase, getFirestore}) => {
    const firestore = getFirestore();
    const documents = [];
    const userDocuments = [];
    const obj = {};
    const dependentDocuments = {};
    const document = await firestore.collection('documents').doc(userId).get()

    if (document.data() && Object.keys(document.data()).length) {
      const ollDoc = document.data();
      for (let key in ollDoc) {
        documents.push(ollDoc[key])
      }
      ;

      documents.forEach(doc => {
        if (dependentDocuments[doc.virusId]) {
          dependentDocuments[doc.virusId] = {
            ...dependentDocuments[doc.virusId],
            virusDocments: [...dependentDocuments[doc.virusId].virusDocments, doc]
          }
        } else {
          dependentDocuments[doc.virusId] = {
            virusName: doc.title,
            virusId: doc.virusId,
            virusDocments: [doc],
            patientId: doc.patientId
          }
        }
      });

      obj.dependentDocuments = dependentDocuments;
      obj.parentId = userId;
      userDocuments.push(obj);

    }
    ;
    return dispatch(setPatientViruses(userDocuments));
  };
};

export const setPatientViruses = (viruses) => {
  return {
    type: SET_PATIENTS_VIRUSES,
    payload: viruses
  };
};

export const setCurrentPatients = (currentPatients) => {
  return {
    type: SET_CURRENT_PATIENTS,
    payload: currentPatients
  };
};

export const getPatientDependentsViruses = (dependents) => {
  return async (dispatch, getState, {getFirebase, getFirestore}) => {
    const firestore = getFirestore();
    const allDocuments = [];

    if (dependents) {
      const array = Object.keys(dependents).map(async (dependent) => {
        const snap = await firestore.collection('documents').doc(dependent).get()
        return snap
      });

      const result = await Promise.all(array);
      const dependentsViruses = result.map(snap => snap.data())

      dependentsViruses.forEach(dependDoc => {
        const depId = Object.values(dependDoc)[0];
        const depDocuments = [];
        const obj = {};
        const dependentDocuments = {};

        for (let key in dependDoc) {
          depDocuments.push(dependDoc[key]);
        }
        ;

        depDocuments.forEach(doc => {
          if (dependentDocuments[doc.virusId]) {
            dependentDocuments[doc.virusId] = {
              ...dependentDocuments[doc.virusId],
              virusDocments: [...dependentDocuments[doc.virusId].virusDocments, doc]
            }
          } else {
            dependentDocuments[doc.virusId] = {
              virusName: doc.title,
              virusId: doc.virusId,
              virusDocments: [doc],
              patientId: doc.patientId
            }
          }
        });

        obj.patientFullName = depId.patientFullName;
        obj.patientId = depId.patientId;
        obj.dependentDocuments = dependentDocuments;

        allDocuments.push(obj);
      })
    }
    ;

    return dispatch(setPatientDependentsViruses(allDocuments));
  };
};

export const setPatientDependentsViruses = (viruses) => {
  return {
    type: SET_PATIENTS_DEPENDENTS_VIRUSES,
    payload: viruses
  };
};

export const setPatientAllViruses = (viruses) => {
  return {
    type: SET_PATIENTS_ALL_VIRUSES,
    payload: viruses
  };
};

export const addAvatar = ({file, userId}) => {
  return (dispatch, getState, {getFirebase, getFirestore}) => {
    const fireStore = getFirestore();
    const s3Id = `${userId}-${Math.random().toString(36).substr(2, 9)}`;

    s3Upload(file, s3Id)
      .then(res => {
        fireStore.collection('users').doc(userId).set({avatar: res.key}, {merge: true})
          .catch((error) => (
            dispatch(showAlert({type: 'error', message: error.message}))
          ));
      })
      .catch(error => error);
  };
};

const addPatientUseFirebase = (dispatch, getFirestore, dataHcProvider) => {
  const firestore = getFirestore();
  const arrayUnion = firestore.FieldValue.arrayUnion;
  const timestamp = firestore.FieldValue.serverTimestamp();
  const timestampNow = firestore.Timestamp.now();
  const s3Id = `${dataHcProvider.userId}-${dataHcProvider.virusId}-${Math.random().toString(36).substr(2, 9)}`;

  dispatch(setLoadSpinner(true));

  firestore.collection('patients').doc(dataHcProvider.hcProviderId).set({
    list: arrayUnion(dataHcProvider.userId)
  }, {merge: true})
    .then(async () => {
      await s3Upload(dataHcProvider.file, s3Id)
        .then(async (res) => {
          const parentId = dataHcProvider.parent ? dataHcProvider.parent : dataHcProvider.userId;

          const document = {
            [res.key.replace('.', '')]: {
              documentId: res.key.replace('.', ''),
              documentOwner: dataHcProvider.userId,
              timestamp: timestampNow
            }
          };

          await firestore.collection('users').doc(parentId).set({
            documents: document
          }, {
            merge: true
          })
            .catch(error => dispatch(setLoadSpinner(false)))

          await firestore.collection('documents').doc(dataHcProvider.userId).set({
            [res.key.replace('.', '')]: {
              author: dataHcProvider.hcProviderId,
              authorFullName: dataHcProvider.authorFullName,
              docAuthor: "doctor",
              doctorName: dataHcProvider.doctorName,
              expirationDate: dataHcProvider.expirationDate,
              isImmunity: dataHcProvider.isImmunity,
              notes: dataHcProvider.notes.value,
              patientFullName: `${dataHcProvider.firstName} ${dataHcProvider.lastName}`,
              patientId: dataHcProvider.userId,
              s3id: res.key,
              timestamp,
              type: dataHcProvider.file.type,
              typeOfTest: dataHcProvider.typeOfTest,
              virusId: dataHcProvider.virusId,
              allDocuments: [{...res}],
              title: dataHcProvider.virusName
            }
          }, {
            merge: true
          })
            .catch(error => dispatch(setLoadSpinner(false)))

          await firestore.collection('viruses').doc(dataHcProvider.userId).set({
            [dataHcProvider.virusId]: {
              active: true,
              virusID: dataHcProvider.virusId
            }
          }, {
            merge: true
          })
            .catch(error => dispatch(setLoadSpinner(false)))

          await firestore.collection('notifications').doc(dataHcProvider.userId).collection('notification').doc().set({
            author: dataHcProvider.authorFullName,
            document: 'random text',
            isRead: false,
            time: timestamp,
            type: 'update',
            virusId: dataHcProvider.virusName,
            id: dataHcProvider.virusId,
          }, {
            merge: true
          })
            .catch((error) => dispatch(setLoadSpinner(false)));

          await dispatch(getPatientsHcProvider(dataHcProvider.hcProviderId));
          await dispatch(filterDocumentsUser(parentId));

        })
        .catch((error) => dispatch(setLoadSpinner(false)));
    })
    .catch((error) => dispatch(setLoadSpinner(false)));
};

export const filterDocumentsUser = (parentId) => {
  return async (dispatch, getState, {getFirebase, getFirestore}) => {
    const firestore = getFirestore();
    const amountElements = 5; // max amount documents for parent user

    const puserParentData = await firestore.collection('users').doc(parentId).get();

    if (puserParentData.data().documents) {

      const array = Object.values(puserParentData.data().documents);
      const removeDocuments = array
        .sort((a, b) => a.timestamp.seconds - b.timestamp.seconds)
        .reverse();

      removeDocuments.splice(0, amountElements);

      if (removeDocuments.length) {
        removeDocuments.forEach(async (document) => {

          await firestore.collection('users').doc(parentId).update({
            [`documents.${document.documentId}`]: firestore.FieldValue.delete()
          });

          await firestore.collection('documents').doc(document.documentOwner).update({
            [`${document.documentId}`]: firestore.FieldValue.delete(),
          });

        });
      }
      ;
    }
    ;

    dispatch(setLoadSpinner(false));
    dispatch(showAlert({type: '', message: 'Document added successfully'}));
  };
};

export const addPatient = (dataHcProvider) => {
  return async (dispatch, getState, {getFirebase, getFirestore}) => {
    if (dataHcProvider.type === "immunity") {
      const status = dataHcProvider.isImmunity ? 2 : 1;
      const userId = `${dataHcProvider.userId}-${dataHcProvider.virusId}`;
      const data = {userId, status};

      const response = await setAWSLamda(data);

      if (response.status === 200) {
        addPatientUseFirebase(dispatch, getFirestore, dataHcProvider);
      }

    } else {
      addPatientUseFirebase(dispatch, getFirestore, dataHcProvider);
    }
  };
};

export const addNewPatient = (data, virusName) => {
  return async (dispatch, getState, {getFirebase, getFirestore}) => {
    const firestore = getFirestore()
    const timestamp = firestore.FieldValue.serverTimestamp();
    const isEmailExist = await firestore
      .collection('users')
      .where('email', '==', data.email.toLowerCase().trim())
      .get();

    if (isEmailExist.docs.length !== 0) {
      dispatch(showAlert({type: 'error', message: 'User with this email already exist, use QR code for add user to patients'}))
    } else {
      const s3Id = `${data.hcProviderId}-${data.virusId}-${Math.random().toString(36).substr(2, 9)}`;
      await s3Upload(data.file, s3Id).then( async res => {
         fetch(
          'https://us-central1-unity-61a0c.cloudfunctions.net/sendInvitationalEmail',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify({
              email: data.email.toLowerCase().trim(),
            }),
          },
        );


        await firestore
          .collection('pended_notifications')
          .doc(data.email.toLowerCase().trim())
          .set({
            author: data.hcProviderId,
            document: 'doctor',
            expirationDate: data.expirationDate,
            s3Id: res.key,
            isRead: false,
            timestamp,
            type: 'update',
            email: data.email,
            allDocuments: [{...res}],
            isImmunity: data.isImmunity,
            doctorName: data.doctorName,
            typeOfTest: data.typeOfTest,
            notes: data.notes?.value,
            imgType: data.file?.type,
            title: virusName,
            docAuthor: 'doctor',
            virusId: data.virusId,
            patientFullName: `${data.firstName} ${data.lastName}`,
            authorFullName: data.authorFullName,
          });
      })
    }
  }
}

export const searchUserForId = (userId) => {
  return async (dispatch, getState, {getFirebase, getFirestore}) => {
    const firestore = getFirestore();
    try {
      const response = await firestore
        .collection('users')
        .where('hcId', '==', userId.trim())
        .get();

      if (response.docs.length !== 0) {
        dispatch(setUserForId([response.docs[0].data()]))
      } else {
        dispatch(setUserForId([]))
      }
    } catch (e) {

    }

  };
};

const setUserForId = (user) => {
  return {
    type: SET_USER_FOR_ID,
    payload: user
  };
};
